import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87633898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_modal_wrap" }
const _hoisted_2 = { class: "modal_place_input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 分类名称 ")
], -1))
const _hoisted_4 = { class: "modal_place_input_content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_place_input_hint" }, "标题文本不能超过六个字，超过自动省略隐藏。", -1))

import { withDefaults, reactive, watch, ref } from 'vue';

interface IProps {
  modelValue: any;
}

const __default__ = { name: 'ModalCreatePlace' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: {
    file_name: '',
  } }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: any };


const form = ref(props.modelValue);


watch(
  () => props.modelValue,
  () => {
    form.value = props.modelValue;
  }
);
watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_input, {
          value: form.value.file_name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.file_name) = $event)),
          class: "mpic_input"
        }, null, 8, ["value"])
      ])
    ]),
    _hoisted_5
  ]))
}
}

})